import React from 'react';
import ProjectCard from '../components/proiect-lege-magistrati/ProjectCard';

function ProiectLegeMagistratiPage() {
  return <ProjectCard />;
}

export default ProiectLegeMagistratiPage;
